export enum CompanyType {
  THERAPEUTIC = 'therapeutic',
  DEVICE = 'device',
}

export interface Company {
  id: string;
  name: string;
  website?: string;
  product_website?: string;
  ticker?: string;
  exchange?: string;
  corporate_status?: string;
  former_names?: string[];
  acquired_by_company_id?: string;
  summary_description?: string;
  description?: string;
  quartr_company_id?: string;
  company_type?: CompanyType[];
  feed_sec?: string;
  feed_news_rss?: string;
  feed_events?: string;
  feed_press_release?: string;
  email_press_feed?: string;
  press_release_url?: string;
  website_content_archive_url?: string;
  attribution_statement?: string;
  update_technologies?: boolean;
  completion_score?: number;
  coverage_priority?: string;
  date_updated?: string;
  technologies?: Array<{ id: string; name: string }>;
}

export interface CompanyCreate {
  id?: string;
  name: string;
  website?: string;
  product_website?: string;
  ticker?: string;
  exchange?: string;
  corporate_status?: string;
  former_names?: string[];
  acquired_by_company_id?: string;
  summary_description?: string;
  description?: string;
  quartr_company_id?: string;
  company_type?: CompanyType[];
  feed_sec?: string;
  feed_news_rss?: string;
  feed_events?: string;
  feed_press_release?: string;
  email_press_feed?: string;
  press_release_url?: string;
  website_content_archive_url?: string;
  attribution_statement?: string;
  update_technologies?: boolean;
  completion_score?: number;
  coverage_priority?: string;
}

export interface CompanyUpdate {
  name?: string;
  website?: string;
  product_website?: string;
  ticker?: string;
  exchange?: string;
  corporate_status?: string;
  former_names?: string[];
  acquired_by_company_id?: string | null;
  summary_description?: string;
  description?: string;
  quartr_company_id?: string | null;
  company_type?: CompanyType[];
  feed_sec?: string;
  feed_news_rss?: string | null;
  feed_events?: string;
  feed_press_release?: string | null;
  email_press_feed?: string;
  press_release_url?: string | null;
  website_content_archive_url?: string;
  attribution_statement?: string;
  update_technologies?: boolean;
  completion_score?: number;
  coverage_priority?: string | null;
}

export interface CompanyListItem {
  id: string;
  name: string;
  website?: string;
  ticker?: string;
  corporate_status?: string;
  former_names?: string[];
  acquired_by_company_id?: string;
  summary_description?: string;
}
